<template>
  <div class="control-center" :data-orientation="broadcast.metadata.orientation">
    <Player ref="player" />
    <div class="apps">
      <card-minimal id="chat" class="flex" v-if="broadcast.event_details.chat.enable">
        <chat />
      </card-minimal>
      <card-minimal id="apps" class="flex o-h" v-if="hasApps">
        <header>
          <ul>
            <li v-if="productAccess" :data-active="currentApp === 'products'" @click="currentApp = 'products'">Products <span v-if="productsCount > 0">{{ productsCount }}</span></li>
            <li v-if="giveawayAccess" :data-active="currentApp === 'giveaway'" @click="currentApp = 'giveaway'">Giveaway <span v-if="giveawaysCount > 0">{{ giveawaysCount }}</span></li>
            <li v-if="formAccess" :data-active="currentApp === 'forms'" @click="currentApp = 'forms'">Forms <span v-if="formsCount > 0">{{ formsCount }}</span></li>
            <li v-if="pollAccess" :data-active="currentApp === 'polls'" @click="currentApp = 'polls'">Polls</li>
          </ul>
        </header>
        <div class="apps-inner">
          <products-list v-if="productAccess" @addProduct="modals.products = true" :showTime="true" @gotoInVideo="$refs.player.goto($event)" :show="currentApp === 'products'" />
          <giveaway-list v-if="giveawayAccess" :show="currentApp === 'giveaway'" />
          <forms-list v-if="formAccess" :show="currentApp === 'forms'" />
        </div>
      </card-minimal>
    </div>

    <Form v-if="formAccess" />
    <Giveaway v-if="giveawayAccess" />
  </div>
</template>

<script>

import ProductsList from '@/components/Products/ProductsList.vue';
import FormsList from '@/components/Forms/FormsList.vue';
import Form from '@/components/Forms/Form.vue';
import GiveawayList from '@/components/Giveaway/GiveawayList.vue';
import Giveaway from '@/components/Giveaway/Giveaway.vue';
import Chat from '@/components/Chat/Index.vue';

import Player from './Player.vue';

export default {
  components: {
    Form,
    FormsList,
    Player,
    ProductsList,
    GiveawayList,
    Giveaway,
    Chat,
  },
  computed: {
    /**
     * Get the current broadcast in store
     * @returns {Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    giveawayAccess() {
      return this.accountSettings?.subscription?.giveaway;
    },
    formAccess() {
      return this.accountSettings?.subscription?.giveaway;
    },
    pollAccess() {
      return this.accountSettings?.subscription?.poll;
    },
    productAccess() {
      return this.broadcast.event_details.shopping.enable && this.liveshoppingEnabled && this.featuresEnabled.includes('lvs') && this.activeSubscription;
    },
    formsCount() {
      return this.$store.getters['Forms/forms'].length;
    },
    giveawaysCount() {
      return this.$store.getters['Giveaway/giveaways'].length;
    },
    productsCount() {
      return this.$store.getters['Products/broadcastProducts'].length;
    },
    hasApps() {
      return this.productAccess || this.formAccess || this.giveawayAccess || this.pollAccess;
    },
  },
  data() {
    return {
      currentApp: 'products',
      modals: {
        products: false,
        forms: false,
        giveaway: false,
        poll: false,
      },
    };
  },
  mounted() {
    if (this.hasApps) {
      if (this.productAccess) {
        return;
      }

      this.currentApp = 'giveaway';
    }
  },
  beforeDestroy() {
    this.$store.commit('Forms/clearEventForms');
  },
};
</script>

<style lang="scss" scoped>
.control-center {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &[data-orientation="landscape"] {
    .apps {
      display: flex;
      gap: 16px;
      min-width: 0;
      flex-direction: column;

      & > * {
        flex: 1;
        min-height: 300px;

        @media (max-width: 767px) {
          max-height: 500px;
        }
      }

      @media (min-width: 768px) {
        flex-direction: row;

        & > * {
          min-height: 50vh;
          max-height: calc(75vh - 64px);
        }
      }
    }
  }

  &[data-orientation="portrait"] {
    @media (min-width: 768px) {
      flex-direction: row;
    }

    & > .apps {
      display: flex;
      flex: 2;
      flex-direction: column;
      gap: 16px;
      min-width: 0;

      & > * {
        min-height: 300px;
        @media (max-width: 767px) {
          max-height: 500px;
        }
        flex: 1;
      }

      @media (min-width: 768px) {
        max-height: calc(100vh - 64px);
      }

      @media (min-width: 1024px) {
        flex-direction: row;
        max-height: calc(100vh - 64px);
      }
    }
  }

  #apps {
    header {
      border-bottom: 1px solid #EEF0F9;
      ul {
        display: flex;
        border-radius: 10px 10px 0 0;
        overflow: hidden;

        & > * {
          color: #0060FF;
          font-weight: 500;
          flex: 1;
          text-align: center;
          padding: 16px 8px;
          box-shadow: inset -1px 0 0 0 #EEF0F9;
          cursor: pointer;

          &[data-active="true"] {
            background-color: #F3F5F9;
            color: #757882;
          }

          span {
            align-items: center;
            justify-content: center;
            background-color: #0060FF;
            display: inline-flex;
            color: white;
            border-radius: 10px;
            width: 20px;
            height: 20px;
            font-size: 10px;
          }
        }
      }
    }

    .apps-inner {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
